/**
 * Склейка адреси торгової точки.
 *
 * У картці ТТ «Місто» й «Адреса» — два незалежні вільні поля без валідації, тож
 * заклади заповнюють їх як завгодно: найчастіше пишуть усе в «Адреса», а «Місто»
 * лишають порожнім, іноді ж дублюють місто в обох. Наївна склейка дала б
 * «Київ, м. Київ, вул. Х».
 *
 * Цей файл має ідентичну копію в qr-menu — правити одночасно в обох.
 */

// Місто вважаємо вже вписаним в адресу, лише якщо воно стоїть на її початку
// («Київ, вул. Х»). Всередині рядка не шукаємо: «вул. Київська» в Одесі не має
// проковтнути назву міста.
function startsWithCity(address, city) {
  const strip = (v) =>
    v
      .trim()
      .replace(/^м\.?\s*/i, "")
      .toLowerCase();
  const name = strip(city);
  const rest = strip(address);
  if (!name || !rest.startsWith(name)) return false;
  // «Київська» теж починається з «Київ», але це вже інше слово.
  const tail = rest.slice(name.length);
  return tail === "" || /^[^\p{L}]/u.test(tail);
}

export function joinCityAddress(city, address) {
  const c = (city || "").trim();
  const a = (address || "").trim();
  if (!c) return a;
  if (!a) return c;
  return startsWithCity(a, c) ? a : `${c}, ${a}`;
}
